import { BrowserRouter } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/layout/ScrollToTop";
import AppRoutes from "./routes/AppRoutes";
import "./styles/global.css";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />

            <div className="app">
                <Navbar />

                <main className="main-content">
                    <AppRoutes />
                </main>

                <Footer />
            </div>
        </BrowserRouter>
    );
}

export default App;